import { useState } from 'react'
import { useField } from 'remix-validated-form'
import { AppConfig } from '~/AppConfig'
import type { PhoneInputFieldProps } from '~/components/shared'
import { PhoneInputField } from '~/components/shared'

const PhoneInput_v2 = (
  props: Omit<PhoneInputFieldProps, 'onChange'> & {
    onChange?: (value: string | undefined) => void
  },
) => {
  const { onChange, helperText, name, ...restProps } = props
  const { error, getInputProps } = useField(name!, {
    validationBehavior: AppConfig.InputValidationBehavior,
  })
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(props.value)

  let inputValue, onChangeHandler
  if (typeof onChange === 'function') {
    inputValue = props.value
    onChangeHandler = onChange
  } else {
    inputValue = phoneNumber
    onChangeHandler = setPhoneNumber
  }

  return (
    <>
      <input type="hidden" name="includePhoneNumber" defaultValue={inputValue} />
      <PhoneInputField
        {...getInputProps({
          value: inputValue,
          onChange: onChangeHandler,
          error: !!error,
          helperText: error || helperText || '',
          ...restProps,
        })}
      />
    </>
  )
}

export default PhoneInput_v2
